import script from "./deliverDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./deliverDetail.vue?vue&type=script&setup=true&lang=js"

import "./deliverDetail.vue?vue&type=style&index=0&id=04d7fe6a&lang=css"

const __exports__ = script;

export default __exports__